import ActivityContext, {IActivity, IPosition} from "../contexts/Activity.tsx";
import {IResolvedActivity} from "../contexts/Activity.tsx";
import {useDroppable, useDndMonitor, useDraggable, DragOverlay} from '@dnd-kit/core';
import {useContext, useEffect, useRef, useState} from "react";
import {ReactSVG} from "react-svg";
import {IPoint,calcTopOfPath} from "../helpers/calTopOfPath.ts";
import {isMobile, isTablet} from "../helpers/isMobile.ts";

interface IPersonAreaProps{
    Activity : IActivity
}
export function PersonArea ({Activity} : IPersonAreaProps) {
    // @ts-ignore
    const  {avatar, resolveActivity, resolvedActivity}  = useContext(ActivityContext);
    const {isOver, setNodeRef } = useDroppable({
        id: 'droppable',
    });
    const {attributes, listeners, setNodeRef : NodeRef, transform} = useDraggable({
        id: 'resolved',
    });
    const [heading1Point,setheading1Point] = useState<SVGPoint|null>(null);
    const [heading2Point,setheading2Point] = useState<SVGPoint|null>(null);
    const myRef = useRef(null);
    const calcHedingPositions = () =>{
        const k = isMobile() ? 0.7 : 1;
        const container = document.querySelector('.halo');
        const containerParent = document.querySelector('.personArea');
        const dx = containerParent.clientWidth/2 - container.clientWidth/2 * k;
        const dy = containerParent.clientHeight/2 - container.clientHeight/2 * k;

        const line_1 = document.querySelector('path.inner-line') as SVGPathElement;
        const line_2 = document.querySelector('path.middle-line') as SVGPathElement;
        let point;

        if(line_1){
            point= calcTopOfPath(line_1);
            point.x = point.x * k + dx;
            point.y = point.y * k + dy;
            setheading1Point(point)
        }
        if(line_2){
            point= calcTopOfPath(line_2);
            point.x = point.x * k + dx;
            point.y = point.y * k  + dy;
            setheading2Point(point)
        }

    }
    // window.svgEl && !heading1Point && calcHedingPositions();
    useEffect(() => {
        if(resolvedActivity && myRef){
            // @ts-ignore
            window.dragoffset ={
                // @ts-ignore
                x : myRef.current.getBoundingClientRect().left | 0,
                // @ts-ignore
                y : myRef.current.getBoundingClientRect().top | 0
            }
        }
    }, [myRef,resolvedActivity]);
    useEffect(() => {
        setTimeout(()=>{
            calcHedingPositions();
        },500);

    }, []);
    useDndMonitor({
        onDragEnd : (event) =>{
            const DISTINCTION = isMobile() ? 0 : isTablet() ? 60 : 125;
            const obj = {
                activity : Activity,
                position : {
                    // @ts-ignore
                    x : window.dragoffset.x + event.delta.x,
                    // @ts-ignore
                    y : window.dragoffset.y + event.delta.y,
                    parentWidth : event.over?.rect.width || 0,
                    parentHeight : event.over?.rect.height || 0
                },
                r : 0,
                scale : 1,
            }
            console.log(obj.position)
            if(
                obj.position.x + DISTINCTION * 1.2 > obj.position.parentWidth ||
                obj.position.y + DISTINCTION *1.2 > obj.position.parentHeight ||
                obj.position.x + DISTINCTION * 0.9 < (isMobile() ? -70 : 0) ||
                obj.position.y + DISTINCTION * 0.9 < (isMobile() ? -70 : 0) ||
                (
                    isMobile() &&
                    obj.position.y +30 > window.innerHeight - (document.querySelector('.selectingAside')?.clientHeight || 0)
                )
            ){
                return;
            }
            resolveActivity(obj);
        }
    })
    return (<div className={'personArea'+' '+ avatar.color} ref={setNodeRef}>
        <span className={"activityExample"}  style={heading2Point ? {
            top : heading2Point.y,
            opacity : 1
        } : {}}>פעילות אהובה</span>
        <span className={"favourite-activityExample"} style={heading1Point ? {
            top : heading1Point.y,
            opacity : 1
        } : {}}>פעילות אהובה מאד</span>
        {/*get the selected avatar*/}
        <span className={'personItem'}>
                    {avatar && <ReactSVG src={avatar.image}
                              beforeInjection = {(svg) => {
                                  svg.setAttribute('width', (avatar.width * 1.61)+'px')
                                  svg.setAttribute('height', (avatar.height * 1.61)+'px')
                              }}
                    />}
        </span>
        { avatar && <ReactSVG className={'halo'} src={avatar.halo}
            afterInjection={(svg) =>  {
                const halos = svg.querySelectorAll('path');
                window.svgEl = svg;
                svg.setAttribute('width', avatar.haloWidth + 'px')
                svg.setAttribute('height', avatar.haloHeight+ 'px')
            }}
        />}
        {resolvedActivity &&<button type={"button"} {...listeners} {...attributes} ref={NodeRef} style={{
            // scale: '30%',
            position: 'absolute',
            left : (resolvedActivity.position.x)+'px',
            top : resolvedActivity.position.y+'px',
            touchAction : 'none'
        }}>
            <div ref={myRef}><ReactSVG src={resolvedActivity.activity.image} /></div>
            <DragOverlay className={'drag-el'} style={{
                // pointerEvents : 'none'
            }} dropAnimation={null}>
                    <ReactSVG src={Activity.image} style={{
                        // pointerEvents : 'none'
                    }}  />
            </DragOverlay>
        </button>}
    </div>);
}